import { Box, type TextProps } from '@mantine/core'
import AppText from './AppText'

export type GunSlopWordmarkSize = 'xs' | 'sm' | 'md' | 'auth' | 'hero'

const sizeSx: Record<GunSlopWordmarkSize, TextProps['sx']> = {
  xs: { fontSize: 12, letterSpacing: 1, lineHeight: 1.2 },
  sm: { fontSize: 18, letterSpacing: 2, lineHeight: 1.2 },
  md: { fontSize: 22, letterSpacing: 2, lineHeight: 1 },
  auth: { fontSize: 24, letterSpacing: 2, lineHeight: 1.2 },
  hero: {
    fontSize: 'clamp(40px, 6vw, 64px)',
    letterSpacing: 2,
    lineHeight: 1.1,
    textAlign: 'center'
  }
}

export type GunSlopWordmarkProps = Omit<TextProps, 'children'> & {
  size?: GunSlopWordmarkSize
  /** Inline with surrounding copy (footers, sentences). */
  inline?: boolean
  /** Override accent for contexts that cannot use CSS variables (e.g. share-card export). */
  slopColor?: string
}

/** Branded logotype: GUN + accent SLOP (Oswald). */
export default function GunSlopWordmark ({
  size = 'md',
  component = 'span',
  inline = false,
  slopColor,
  sx,
  ...rest
}: GunSlopWordmarkProps) {
  return (
    <AppText
      component={component}
      sx={{
        fontFamily: 'Oswald, sans-serif',
        fontWeight: 700,
        color: 'var(--gs-text)',
        margin: 0,
        display: inline ? 'inline' : undefined,
        verticalAlign: inline ? 'baseline' : undefined,
        ...sizeSx[size],
        ...sx
      }}
      {...rest}
    >
      GUN
      <Box component="span" sx={{ color: slopColor ?? 'var(--gs-accent)' }}>
        SLOP
      </Box>
    </AppText>
  )
}
